import React, { createContext, useContext, useState } from 'react';
import {consoleDevLog} from "../apiConfig";

export const ReportContext = createContext();

export const useReports = () => {
    return useContext(ReportContext);
};

export const ReportProvider = ({ children }) => {
    const [reports, setReports] = useState([
        // Initially populated with your sample reports or fetched from a server.
    ]);

    const addReport = (report) => {
        consoleDevLog('Adding report to context with data:', report);
        setReports(prevReports => [...prevReports, report]);
    };

    return (
        <ReportContext.Provider value={{ reports, addReport }}>
            {children}
        </ReportContext.Provider>
    );
};
